import { api } from '.';
import { ActivityRequest, ActivityResponse } from '../types';

const getActivity = async (body: ActivityRequest) => {
  return api<ActivityResponse>('/api/v1/activity', body);
};

export default getActivity;
